import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../Theme/theme';

/**
 * The tallest the preview is drawn. A pixel cap rather than a percentage: the box shrink-wraps the
 * image so the overlay anchors to the picture itself, which leaves its height indefinite and makes
 * a percentage cap resolve to none.
 */
const PREVIEW_MAX_HEIGHT = 400;

const THUMB_SIZE = 18;
// The track and thumb are drawn by the browser, so their shadow cannot come from a palette token.
const THUMB_SHADOW = '0 2px 4px rgba(0, 0, 0, .2)';

const thumb = {
	background: THEME.colors.primary.main,
	border: `2px solid ${THEME.colors.background.light}`,
	borderRadius: '50%',
	boxShadow: THUMB_SHADOW,
	cursor: 'pointer',
	height: THUMB_SIZE,
	width: THUMB_SIZE,
};

export const styleSheet = StyleSheet.create({
	preview: {
		display: 'inline-block',
		lineHeight: 0,
		maxWidth: '100%',
		position: 'relative',
	},
	previewImage: {
		borderRadius: THEME.common.borderRadius,
		display: 'block',
		maxHeight: PREVIEW_MAX_HEIGHT,
		maxWidth: '100%',
	},
	logo: {
		background: THEME.colors.background.light,
		borderTopLeftRadius: THEME.common.borderRadius,
		bottom: SPACE[4],
		boxSizing: 'border-box',
		position: 'absolute',
		right: 0,
	},
	logoTransparent: {
		background: 'transparent',
	},

	sliderContainer: {
		width: '100%',
	},
	sliderHeader: {
		alignItems: 'center',
		color: THEME.colors.text.light,
		display: 'flex',
		fontSize: THEME.typography.fontSizes.sm,
		fontWeight: THEME.typography.fontWeights.bold,
		justifyContent: 'space-between',
		marginBottom: SPACE[8],
	},
	sliderValue: {
		color: THEME.colors.primary.main,
	},
	slider: {
		appearance: 'none',
		background: THEME.colors.border.main,
		borderRadius: THEME.common.borderRadius,
		height: 6,
		outline: 'none',
		WebkitAppearance: 'none',
		width: '100%',
		'::-webkit-slider-thumb': {
			...thumb,
			appearance: 'none',
			WebkitAppearance: 'none',
		},
		'::-moz-range-thumb': {
			...thumb,
			border: 'none',
		},
		':focus-visible': {
			outline: `2px solid ${THEME.colors.primary.main}`,
			outlineOffset: 4,
		},
	},
});
